<template>
  <div id="wrapper">
    <slot name="main-header"></slot>
    <router-view></router-view>
    <slot name="main-footer"></slot>
  </div>
</template>

<script>
export default {
  name: "MainLayout"
};
</script>
